<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' @child-event='getDataValue' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>


		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" v-bind:disabled="isDisabled" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess
	} from '@/api/approval'
	import {
		getRelation,
		getEmpInfo
	} from '@/api/employee'
	import {
		getDepartmentRelationByName
	} from '@/api/department'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getEmployeeRelation();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法

			clickChoose(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var user = res.result.userList[0];
						dataVal.Values.push([user.id, user.name]);
						dataVal.Value = user.name;
					}
				})
			},
			getTemplate: async function() {
				this.listLoading = true;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var departs = this.logInfo.fullName.split("/");
				const empNo = this.logInfo.EmpNo;
        		console.log('departs',departs)
				if(departs.indexOf("二级市场营运中心")==-1&&
				departs.indexOf("代理")==-1&&
				departs.indexOf("商业地产部")==-1&&
				departs.indexOf("住宅部")==-1&&
				departs.indexOf("藤云")==-1&&
				departs.indexOf("房友圈")==-1&&
				departs.indexOf("新媒体中心")==-1&&
				departs.indexOf("综合事务部")==-1){
					this.Message({
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled = true;
				}
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					for (const item of controls.TemplateContent.Controls) {
						var departs = this.logInfo.fullName.split("/");
						if (item.Property.Title[0].Text == "审批行政助理") {
							item.Values = [
								['SC24000029', '钟志斌']
							];
							await getDepartmentRelationByName(title, false).then(res => {
								var nodes = res.Body[0].Nodes;
								nodes.forEach((node) => {
									var superior = node.Items;
									if (superior != null) {
										superior.forEach((val) => {
											if (val.PositionName.indexOf("行政助理") > -1) {
												item.Value = val.EmpName;
												item.Values = [
													[val.EmpNo, val.EmpName]
												]
												return;
											}
										})
										if (item.Value == null) {
											superior.forEach((val) => {
												if (val.PositionName.indexOf("行政主任") > -1) {
													item.Values = [
														[val.EmpNo, val.EmpName]
													]
													return;
												}

											})
										}
									}
								})
							});
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "成交编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "是否成交") {
							item.IsShow = false;
						}
						//交管审批的字段
						if (item.Property.Title[0].Text == "成交编号　") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "成交日期") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "其他情况") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "开户名") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "开户银行") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "账号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "其他支付方式") {
							item.IsShow = false;
						}

						if (item.Property.Title[0].Text == "请选择审批行政助理") {
							if (departs.indexOf("住宅部") > -1) {
								item.IsShow = true;
							} else {
								item.Values = [];
								item.Values.push(this.$store.state.defaultMember);
								item.Value = "默认总经理"
								item.IsShow = false;
							}
						}
						if (item.Property.Id == "Tips-1602636635574") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "逐级审批使用") {
							item.Values = [];
							if (departs.indexOf("商业地产部") > -1) {
								item.Values = this.getRelationList(this.relationList, 6);
							}
							if (departs.indexOf("二级市场营运中心") > -1 || departs.indexOf("代理") > -1) {
								item.Values = this.getRelationList(this.relationList, 8);
							}
							if (departs.indexOf("住宅部") > -1) {
								item.Values = this.getRelationList(this.relationList, 8);
                if (title.indexOf("华西区/四川中原物业顾问有限公司/营业部/住宅部/北区/冯阳战区/金沙云庭(王李玉)分行") !== -1){
                  item.Values = [["SC19002532","王李玉"],["SC13050109","冯阳"],["HB12030069","潘强龙"]]
                  if (empNo === "SC19002532"){
                    item.Values = [["SC13050109","冯阳"],["HB12030069","潘强龙"]]
                  }
                }
                if (title.indexOf("华西区/四川中原物业顾问有限公司/营业部/住宅部/北区/冯阳战区/金沙(董平)分行") !== -1){
                  item.Values = [["SC22000388","董平"],["SC13050109","冯阳"],["HB12030069","潘强龙"]]
                  if (empNo === "SC22000388"){
                    item.Values = [["SC13050109","冯阳"],["HB12030069","潘强龙"]]
                  }
                }
							}
							if (departs.indexOf("藤云") > -1) {
								if(departs.indexOf("藤云拓展部")==-1&&
								departs.indexOf("藤云渠道部")==-1&&
								departs.indexOf("网络直销部")==-1&&
								departs.indexOf("按揭金融服务中心")==-1&&
								departs.indexOf("事业部")==-1 && this.logInfo.EmpNo != "SC16002267"){
									this.Message({
										message: '没有申请权限',
										type: 'error',
										duration: 1000
									});
									this.isDisabled = true;
								}
                console.log(this.relationList)
								for(var i = 0; i < this.relationList.length;i++){
								  if (this.relationList[i].Items == null || this.relationList[i].Items == undefined){
								    continue
                  }
									for(var j = 0;j < this.relationList[i].Items.length;j++){
										if(this.relationList[i].Items[j].JobLevel == 7){
											item.Values.push([this.relationList[i].Items[j].EmpNo,this.relationList[i].Items[j].EmpName]);
											break;
										}
									}
								}
							}
							if (item.Values == null || item.Values.length <= 0) {
								//审批节点无人，跳过
								item.Values.push(this.$store.state.defaultMember);
							}
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "部门") {
							var departs = title.split("/");
							item.Value = "藤云" + departs[departs.indexOf("藤云") + 1] + "/" + this.logInfo.DeptName;
						}
					}
          console.log(1)
          this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					// 合作信息费选项
					var cooperationInformation = '';
					this.templateData.TemplateContent.Controls.forEach(e => {
						if (e.Property.Title[0].Text == '合作信息费支付方式') {
							if (e.Value != null) {
								e.Config.Selector.Options.forEach(option => {
									if (e.Value == option.Key) {
										cooperationInformation = option.Value[0].Text;
									}
								})
							}
						}
						if (cooperationInformation == '转账') {
							if (e.Property.Title[0].Text == '开户名') {
								e.IsShow = true;
							}
							if (e.Property.Title[0].Text == '开户银行') {
								e.IsShow = true;
							}
							if (e.Property.Title[0].Text == '账号') {
								e.IsShow = true;
							}
						} else if (cooperationInformation == '其他') {
							if (e.Property.Title[0].Text == '其他支付方式') {
								e.IsShow = true;
							}
						}
					})
					this.listLoading = false;
				});
			},
			getEmployeeRelation() {
				getRelation(this.logInfo.EmpNo).then(response => {
					this.relationList = response.Body[0].Nodes;
				});
			},
			getTextVal(val, name) {
				var controls = this.templateData.TemplateContent.Controls;
				var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
				if (name == "合作信息费占总佣金比例") {
					if (val != null && val.length > 0) {
						val = (val.toString().match(/^\d{0,9}/g)[0]) || "";
						controlInfo.Value = val + "%";
					}

				}
			},
			getSelectorVal(val, name) {
				var controls = this.templateData.TemplateContent.Controls;
				var controlInfo = controls.filter(item => item.Property.Title[0].Text == name)[0];
				if (name == "成交信息") {
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "已成交，成交编号" && item.Key == val;
						})[0];
					var controlNum = controls.filter(item => item.Property.Title[0].Text == "成交编号")[0]
					var controlDate = controls.filter(item => item.Property.Title[0].Text == "成交日期")[0]
					if (option != null) {
						controlNum.IsShow = true;
						controlDate.IsShow = true;
						controlNum.Property.Require = 1;
						controlDate.Property.Require = 1;
					} else {
						controlNum.IsShow = false;
						controlDate.IsShow = false;
						controlNum.Property.Require = 0;
						controlDate.Property.Require = 0;
					}
				}
				if (name == "信息费税费") {
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Value[0].Text == "其他情况(先咨询财务部)" && item.Key == val;
						})[0];
					var controlOther = controls.filter(item => item.Property.Title[0].Text == "其他情况")[0]
					if (option != null) {
						controlOther.IsShow = true;
						controlOther.Property.Require = 1;
					} else {
						controlOther.IsShow = false;
						controlOther.Property.Require = 0;
					}

				}
				if (name == "合作信息费支付方式") {
					var isOther = true;
					var option = controlInfo.Config.Selector.Options
						.filter(item => {
							return item.Key == val;
						})[0];
					var controlName = controls.filter(item => item.Property.Title[0].Text == "开户名")[0]
					var controlBank = controls.filter(item => item.Property.Title[0].Text == "开户银行")[0]
					var controlAccount = controls.filter(item => item.Property.Title[0].Text == "账号")[0]
					var controlOther = controls.filter(item => item.Property.Title[0].Text == "其他支付方式")[0]
					if (option.Value[0].Text == "转账") {
						isOther = false;
					}
					controlName.IsShow = !isOther;
					controlBank.IsShow = !isOther;
					controlAccount.IsShow = !isOther;

					controlName.Property.Require = isOther == true ? 0 : 1;
					controlBank.Property.Require = isOther == true ? 0 : 1;
					controlAccount.Property.Require = isOther == true ? 0 : 1;

					controlOther.IsShow = isOther;
					controlOther.Property.Require = isOther == true ? 1 : 0;
				}
			},
			getDataValue(name, val) {
				if (name == '成交日期' && val != null) {
					var myDate = new Date();
					var month = myDate.getMonth() + 1;
					var date = new Date(Date.parse(val.replace(/-/g, "/")));
					var data = this.templateData.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text == "跨月等特殊情况说明"
					})[0];
					if(month != date.getMonth() + 1){
						data.Property.Require = 1;
					}else{
						data.Property.Require = 0;
					}
				}
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				this.templateData.TemplateContent.Controls.forEach(item => {
					if (item.Property.Title[0].Text == "是否成交") {
						item.IsShow = true;
					}
					//交管审批的字段
					if (item.Property.Title[0].Text == "成交编号　") {
						item.IsShow = true;
					}
				});

				var SummaryList = [];
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];

				var control1 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "项目/分行"
				})[0]
				var control2 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "物业信息"
				})[0]

				if (control1.Value != null && control1.Value.length > 0) {
					var info = {
						SummaryInfo: []
					}
					info.SummaryInfo = [];
					info.SummaryInfo.push({
						"Text": "内容：流程编号 " + control2.Value,
						"Lang": "zh_CN"
					});
					SummaryList.push(info);
				}


				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请部门：" + this.logInfo.DeptName,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);

				var control3 = this.templateData.TemplateContent.Controls.filter(t => {
					return t.Property.Title[0].Text == "申请时间"
				})[0]
				var info = {
					SummaryInfo: []
				}
				info.SummaryInfo = [];
				info.SummaryInfo.push({
					"Text": "申请时间：" + control3.Value,
					"Lang": "zh_CN"
				});
				SummaryList.push(info);
				this.templateData.SummaryList = SummaryList;

				isSubmit = true;
				this.listLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
				});
			}
		},
		watch: {
			relationList: 'getTemplate'
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
